import { render, staticRenderFns } from "./AlertsManagement.vue?vue&type=template&id=4bac14c0&scoped=true&"
import script from "./AlertsManagement.vue?vue&type=script&lang=js&"
export * from "./AlertsManagement.vue?vue&type=script&lang=js&"
import style0 from "./AlertsManagement.vue?vue&type=style&index=0&id=4bac14c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac14c0",
  null
  
)

export default component.exports